import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const initialState = {
    note: "",
    transaction_id: "",
};

function Pingpong({ isOpen, onClose, onSubmit, title }) {
    const [formData, setFormData] = useState(initialState);
    const { t } = useTranslation();

    const handleChangeForm = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        onClose();
        setFormData(initialState);
        onSubmit?.(formData);
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={onClose} isOpen={isOpen} scrollable={true}>
                <div className="modal-header">
                    <h1 className="mb-0">{title || t("Modal App")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={onClose}></i>
                    </div>
                </div>
                <ModalBody>
                    <div class="notice bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                        <div className="d-flex mb-3" style={{ height: '40px' }}>
                            <img src="https://dash.burgerprints.com/assets/img/PingPongLogo.svg" alt="PingPong" />
                        </div>
                        <div class="d-flex flex-stack flex-grow-1">
                            <div class="fw-bold">
                                <div>
                                    <span class="fs-6 text-blue-800">{t("Transfer")}: COTIK - payment@cotik.app (LE BACH HOANG AN)</span>
                                    <button className="btn btn-link text-hover-primary p-0 ms-1" data-tooltip-id="my-tooltip" data-tooltip-content={"Copy"} onClick={() => navigator.clipboard.writeText("payment@cotik.app")} style={{ verticalAlign: "inherit" }}>
                                        <i className="ki-duotone ki-copy"></i>
                                    </button>
                                </div>
                                {/* <div class="fs-6 text-blue-600">
                                    {t("Verifies transaction ID by scanning Gmail for PingPong transaction emails. If transaction is found and valid, automatically tops up user balance.")}
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span>{t("Notes")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={formData?.note || ""}
                            placeholder={t("Notes")}
                            name="note"
                            onChange={handleChangeForm}
                        />
                    </div> */}
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Transaction ID")}</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={formData?.transaction_id || ""}
                            placeholder={t("Transaction ID")}
                            name="transaction_id"
                            onChange={handleChangeForm}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={onClose}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                        onClick={() => {
                            handleSubmit();
                        }}
                    >
                        {t("Process Topup")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default Pingpong;
